<template lang="pug">
    Tabs.coupons
        el-card.contains-table(shadow="always")
            .error(v-if="error")
                template(v-if="error.code")
                    Error(:message="$t(error.message || 'Something went wrong!')" :code="error.code")
                template(v-else)
                    Error(:message="$t('Something went wrong!')" :code="501")
            .coupons-table(v-else)
                //- :row-link-config="productsPaginated.link"
                paginated-items(
                    scope="ex"
                    type="shop_coupon"
                    :loading="loading"
                    :items="couponsPaginated.items"
                    :filters="filters"
                    :show-filters="showFilters"
                    :variables="couponsPaginated.variables"
                    :all-columns="couponsPaginated.allColumns"
                    :active-columns="couponsPaginated.activeColumns"
                    :page-info="couponsPaginated.pageInfo"
                    :sort="sort"
                    @pagination-size-change="handleSizeChange"
                    @pagination-current-change="handleCurrentChange"
                    @show-table-columns="handleColsShow"
                    @change-filter="handleFilterInputChange"
                    @click="handleClick"
                    @change-sort="handleSortInputChange"
                )
                    template(slot="top")
                        el-row.table-top(v-loading="loading" type="flex" justify="space-between")
                            .row
                                .left
                                    el-button(v-if="!sharedShopDataReadOnly" type="primary" size="mini" icon="el-icon-fa-plus fas" @click="addCoupon")
                                        | {{ $t('New Coupon') }}
                                .right.hide-on-empty
                                    el-button(
                                        plain
                                        size="mini"
                                        type="primary"
                                        icon="el-icon-fa-filter fas"
                                        @click="toggleFilterVisiblity"
                                        :disabled="disable.showFilters || hasFilters"
                                    )
                                        span(v-if="showFilters") {{ $t('Hide filters') }}
                                        span(v-else) {{ $t('Show filters') }}
                    template(v-slot:percentage="{ value }")
                        span(v-if="value") {{ value }}%
                    template(v-slot:amount="{ item, value }")
                        span(v-if="value") {{ value | moneyFormat(item.currency ? item.currency.iso4217 : defaultCustomerGroupCurrency) }}
                    template(v-slot:type="{ value }")
                        span(v-if="value === 'fixed'") {{ $t('Fixed amount') }}
                        span(v-if="value === 'percentage'") {{ $t('Percentage') }}
                    template(v-slot:applicable_for="{ value }")
                        span(v-if="value === 'all'") {{ $t('Anyone') }}
                        span(v-if="value === 'anyone'") {{ $t('Anyone') }}
                        span(v-else-if="value === 'customer-group'") {{ $t('Customer Group') }}
                        span(v-else-if="value === 'customer'") {{ $t('Customer') }}
                        span(v-else-if="value === 'new-customer'") {{ $t('New Customer') }}
                        span(v-else-if="value === 'guest'") {{ $t('Guest') }}
                    template(v-slot:actions="{ item }")
                        el-button.delete-button(
                            v-if="!sharedShopDataReadOnly"
                            plain
                            circle
                            size="mini"
                            type="danger"
                            icon="el-icon-fa-trash-alt fas"
                            @click.stop.prevent="openDeleteDialog(item)"
                        )
                        el-button.letter-button(
                            plain
                            circle
                            size="mini"
                            type="info"
                            icon="el-icon-fa-file-lines far"
                            @click.stop.prevent="showLetterDrawer(item)"
                        )
                        el-button.till-roll-button(
                            v-if="enabledExtensions.includes('shop:point-of-sale')"
                            plain
                            circle
                            size="mini"
                            type="info"
                            icon="el-icon-fa-receipt fas"
                            @click.stop.prevent="showTillRollDrawer(item)"
                        )
        coupon-form(
            width="580px"
            :data="modal.form"
            :customer="modal.customer"
            :visibility.sync="modal.visibility"
            :show-applicable-for="true"
            :submit-button-label="$t('Save and close')"
            @close="$emit('focus-search')"
            @closed="resetCouponModal"
            @submit="saveCoupon"
        )
            template(slot="footer-left" slot-scope="{ closeModal, submit }")
                el-button(
                    v-if="!modal.form.id || modal.form.id.startsWith('new:')"
                    size="small"
                    icon="el-icon-fa-times fas"
                    @click="closeModal"
                ) {{ $t('Dismiss') }}
                el-button(
                    v-else-if="modal.form.id"
                    size="small"
                    type="danger"
                    icon="el-icon-fa-trash-alt fas"
                    :loading="modal.deleting"
                    :disabled="modal.loading"
                    @click="deleteCoupon(modal.form.id)"
                ) {{ $t('Delete') }}
            template(slot="footer-right" slot-scope="{ closeModal, submit }")
                el-button(
                    v-if="modal.form.id && !modal.form.id.startsWith('new:')"
                    size="small"
                    icon="el-icon-fa-times fas"
                    @click="closeModal"
                ) {{ $t('Dismiss') }}
                el-button(
                    size="small"
                    type="primary"
                    icon="el-icon-fa-check fas"
                    :loading="modal.saving"
                    :disabled="modal.loading"
                    @click="submit(false)"
                ) {{ $t('Save and close') }}

        el-drawer.document(
            :title="document.title"
            :visible.sync="document.visibility"
            :wrapper-closable="false"
            :modal="true"
            :size="document.size"
            @closed="resetDocument"
        )
            template(v-if="document.data")
                el-form(v-loading="document.loading")
                    section.body(v-if="document.error === false")
                        .preview(
                            ref="preview"
                            :class="{ loaded: !document.loading }"
                        )
                            //- vue-pdf
                            pdf.pdf(
                                ref="pdf-preview"
                                style="width: 320px"
                                :src="previewUrl"
                                :page="document.data.preview.pagination.current"
                                @num-pages="total => updatePreviewPagination('total', total)"
                                @loaded="previewLoaded"
                                @error="previewError"
                            )
                            //- pdf(
                            //-     ref="pdf-preview"
                            //-     :src="previewUrl"
                            //-     @loading="loadingPreview"
                            //- )
                .drawer-footer
                    el-button(
                        round
                        size="mini"
                        icon="el-icon-fa-times fas"
                        @click="closeDocument"
                    ) {{ $t('Dismiss') }}
                    .preview-pagination(v-if="document.data.preview.pagination && document.data.preview.pagination.total > 1")
                        el-pagination(
                            small
                            layout="prev, pager, next"
                            :pager-count="5"
                            :page-size="1"
                            :total="document.data.preview.pagination.total"
                            @current-change="current => updatePreviewPagination('current', current)"
                        )
                    .right-buttons
                        el-button(
                            circle
                            size="mini"
                            type="primary"
                            :disabled="document.loading"
                            icon="el-icon-fa-download fas"
                            @click="downloadPreview"
                        )
                        //- {{ $t('Download') }}
                        el-button(
                            round
                            size="mini"
                            type="primary"
                            :disabled="document.loading"
                            icon="el-icon-fa-print fas"
                            @click="printPreview"
                        ) {{ $t('Print') }}

        el-dialog(
            :title="$t('Delete Coupon')"
            :visible.sync="deleteDialog.visibility"
            :close-on-click-modal="false"
            top="10vh"
            width="460px"
        )
            .body(v-loading="deleteDialog.loading")
                p {{ $t('Do you really want to delete the coupon?') }}
            template(slot="footer")
                .modal-footer
                    .left
                        el-checkbox(v-model="deleteDialog.remember") {{ $t("Don't keep asking") }}
                    .right
                        el-button(
                            size="mini"
                            icon="el-icon-fa-times fas"
                            :disabled="deleteDialog.loading"
                            @click="closeDeleteDialog"
                        ) {{ $t('Cancel') }}
                        el-button(
                            size="mini"
                            type="danger"
                            icon="el-icon-fa-trash-alt fas"
                            :disabled="deleteDialog.loading"
                            @click="() => deleteCoupon(deleteDialog.coupon.id)"
                        ) {{ $t('Delete') }}
</template>

<i18n>
{
    "de": {
        "Fixed amount": "Fester Betrag",
        "Delete Coupon": "Gutschein löschen",
        "Do you really want to delete the coupon?": "Möchten Sie den Gutschein wirklich löschen?",
        "The coupon has been deleted successfully": "Der Gutschein wurde erfolgreich gelöscht!",
        "The coupon could not be deleted!": "Der Gutschein konnte nicht gelöscht werden!",
        "Percentage": "Prozentsatz",
        "New Coupon": "Neuer Gutschein",
        "Show filters": "Filter anzeigen",
        "Hide filters": "Filter verbergen",
        "Coupon list could not be fetched.": "Gutscheinliste konnte nicht abgerufen werden.",
        "Create Coupon": "Gutschein erstellen",
        "Save the coupon and close": "Gutschein speichern und schließen",
        "Coupon could not be saved.": "Gutschein konnte nicht gespeichert werden.",
        "Coupon has been created successfully!": "Gutschein wurde erfolgreich erstellt!",
        "Coupon PDF": "Gutschein PDF",
        "Preview could not be rendered": "Vorschau konnte nicht gerendered werden",
        "Missing PDF": "PDF konnte nicht gefunden werden",
        "Anyone": "Jedem",
        "Customer Group": "Kundengruppe",
        "Customer": "Kunde",
        "New Customer": "Neuer Kunde",
        "Guest": "Gast",
        "Print": "Drucken",
        "Download": "Herunterladen"
    }
}
</i18n>

<script>
import _ from 'lodash';
import uniqid from 'uniqid'
import printJS from 'print-js-updated';
import pdf from 'vue-pdf'

import { adminClient as apolloClient } from '@/store/apollo';
import pinia from '@/pinia';
import { useSetupStore, useShopCouponStore } from '@/stores'

import AuthApi from '@/store/api/system/auth';
import { ensureFreshToken } from '@/helpers';
import CouponApi from '@/extensions/shop/store/api/coupon';
import PurchaseApi from '@/extensions/shop/store/api/purchase';

import CouponForm from '@/extensions/restrictedArea/views/Member/Form/Partials/CouponForm'
import PaginatedItems from '@/components/PaginatedItems';
import Tabs from '@/views/cms/Marketing/Partials/Tabs'
import Error from '@/components/Error'

export default {
    name: 'Coupons',
    data() {
        return {
            error: false,
            disable: {
                showFilters: false,
            },
            visibleTransfer: undefined,
            modal: {
                title: this.$t('Create Coupon'),
                visibility: false,
                loading: false,
                saving: false,
                deleting: false,
                customer: undefined,
                form: {},
                rules: undefined
            },
            deleteDialog: {
                visibility: false,
                loading: false,
                remember: false,
                coupon: undefined
            },
            document: {
                visibility: false,
                context: undefined,
                size: '40%',
                title: undefined,
                loading: false,
                saving: false,
                submit: false,
                error: false,
            },
        };
    },
    components: {
        CouponForm,
        PaginatedItems,
        Error,
        Tabs,
        pdf,
    },
    watch: {
        activeCms(cms) {
            const reload = _.get(cms, 'reloadComponents', true);
            if (reload) this.initialize();
        }
    },
    computed: {
        activeShop() {
            return this.activeCms.shop;
        },
        showFilters() {
            return this.hasFilters || _.get(this.couponsPaginated, 'showFilters') || false;
        },
        hasFilters() {
            return !_.isEmpty(this.filters);
        },
        filters() {
            let filters = _.cloneDeep(this.couponsPaginated.filters);
            delete filters.cms;
            return filters;
        },
        sort() {
            var variables = this.couponsPaginated.variables;
            var defaultSort = this.couponsPaginated.defaultSort || { field: 'id', direction: 'desc' };
            var order = (variables.order !== undefined && variables.order !== '') ? variables.order : defaultSort.field;
            var direction = (variables.direction !== undefined && variables.direction !== '') ? variables.direction : defaultSort.direction;
            return { field: order, direction: direction };
        },
        defaultCustomerGroupCurrency() {
            const code = _.get(this.activeShop, 'defaultCustomerGroup.currency.iso4217');
            return code || 'EUR';
        },
        previewUrl() {
            if (this.document.data) return this.document.data.preview.getUrl();
        },
        setupStore() {
            return useSetupStore(pinia);
        },
        couponStore() {
            return useShopCouponStore(pinia);
        },
        activeCms() {
            return this.setupStore.activeCms;
        },
        enabledExtensions() {
            return this.setupStore.enabledExtensions;
        },
        settingValues() {
            return this.setupStore.settingValues;
        },
        debounce() {
            return this.setupStore.debounce;
        },
        loading() {
            return this.couponStore.loading;
        },
        couponsPaginated() {
            return this.couponStore.couponsPaginated;
        }
    },
    methods: {
        initialize() {
            this.updateLoading(true);
            this.refetch();
        },
        addCoupon() {
            // const params = { id: 'new' };
            // router.push({ name: 'coupon-main', params });
            this.openCouponModal();
        },
        handleClick(item) {
            // const params = { id: item.id };
            // router.push({ name: 'coupon-main', params });
            this.openCouponModal(item);
        },
        handleSizeChange(itemsPerPage) {
            this.updateLoading(true);
            this.defineItemsPerPage(itemsPerPage);
            this.refetch();
        },
        handleCurrentChange(currentPage) {
            this.updateLoading(true);
            this.defineCurrentPage(currentPage);
            this.refetch();
        },
        handleColsShow(visibleColumns) {
            this.defineActiveColumns(visibleColumns);
            // apolloClient.cache.reset()
            apolloClient.clearStore();
        },
        handleFilterInputChange(key, value, debounce = true) {
            //reset currentPage if filtering to find entries on all pages
            this.defineCurrentPage(0)

            this.defineFilterValue({ key, value });
            if (debounce) this.debouncedRefetch();
            else this.refetch();
        },
        handleSortInputChange(key, value) {
            this.defineSort({ key, value });
            this.refetch();
        },
        toggleFilterVisiblity() {
            const visible = this.showFilters;

            let value = false;
            if (!visible) value = true;

            this.disable.showFilters = true;
            this.defineFilterVisibility(value);
            this.saveFilterVisibility({ scope: 'ex', key: 'shop_coupon', value }).finally(
                () => (this.disable.showFilters = false)
            );
        },
        refetch() {
            this.updateLoading(true);
            // always add the cms id to filters
            const cmsID = this.activeCms.id;
            const filter = {
                key: 'cms',
                match: cmsID
            };
            this.defineFilterValue({ key: 'cms', value: filter });

            return this.fetchCouponsPaginated()
                .then(() => this.updateLoading(false))
                .catch(err => {
                    const { graphQLErrors } = err

                    let code = 501;
                    let message = 'An error occurred!';

                    if (graphQLErrors) {
                        code = _.get(graphQLErrors, '0.code') || code;
                        message = _.get(graphQLErrors, '0.message') || message;
                    }

                    let notify = true;
                    switch (code) {
                        case 401:
                            notify = false;
                            this.error = { code, message: 'You are not authorized' };
                            break;
                        case 403:
                            notify = false;
                            this.error = { code, message: 'You are not allowed to be here' };
                            break;
                        // case 404:
                        //     break;
                        default:
                            this.error = true;
                            break;
                    }

                    if (notify) {
                        this.$notify.error({
                            title: this.$t(message),
                            message: this.$t('Coupon list could not be fetched.'),
                            iconClass: 'fas el-icon-fa-times',
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 8000
                        });
                    }

                    this.updateLoading(false);

                    /* eslint no-console: ["error", { allow: ["error"] }] */
                    console.error(err);
                });
        },
        debouncedRefetch: _.debounce(function () {
            // function scope is needed here
            this.updateLoading(true);
            this.refetch();
        }, useSetupStore(pinia).debounce || 300),

        openCouponModal(coupon = null) {
            // this.modal.customer = this.purchaser ? this.purchaser.customer : null
            // if (! this.modal.customer && this.activePointOfSale.customerGroup) {
            //     this.modal.customer = {
            //         id: null,
            //         customerGroup: this.activePointOfSale.customerGroup
            //     }
            // }

            if (coupon) {
                // this.modal.form = _.cloneDeep(coupon);
                // delete this.modal.form.created_at;
                // delete this.modal.form.updated_at;
                this.modal.form = {
                    id: coupon.id,
                    name: coupon.name,
                    description: coupon.description,
                    code: coupon.code,
                    position: coupon.position,
                    type: coupon.type,
                    max_uses: coupon.max_uses,
                    max_uses_per_customer: coupon.max_uses_per_customer,
                    percentage: coupon.percentage,
                    amount: coupon.amount,
                    start_at: coupon.start_at,
                    end_at: coupon.end_at,
                    applicable_for: coupon.applicable_for,
                    customers: coupon.customers,
                    // members: [],
                    customerGroups: coupon.customerGroups,
                    // pivot: { uses: coupon.pivot.uses },
                    discard_the_following_coupons: coupon.discard_the_following_coupons,
                    discard_remaining_amount: coupon.discard_remaining_amount,
                }
            } else {
                this.modal.form = {
                    id: uniqid('new:'),
                    name: undefined,
                    description: undefined,
                    code: uniqid().toUpperCase(),
                    position: undefined,
                    type: 'fixed',
                    max_uses: 1,
                    max_uses_per_customer: undefined,
                    percentage: undefined,
                    amount: undefined,
                    start_at: undefined,
                    end_at: undefined,
                    applicable_for: 'anyone',
                    // customers: [],
                    // members: [],
                    // customerGroups: [],
                    // pivot: { uses: 0 },
                    discard_the_following_coupons: false,
                    discard_remaining_amount: false,
                }
            }

            // const customerGroup = _.get(this.modal, 'customer.customerGroup')
            // const defaultCustomerGroup = _.get(this.activeShop, 'defaultCustomerGroup');
            // if (customerGroup && customerGroup.id !== defaultCustomerGroup.id) {
            //     this.modal.form.applicable_for = 'customer-group'
            //     this.modal.form.customerGroups = [ customerGroup ]
            //     this.modal.form.currency = customerGroup.currency
            // }

            this.modal.visibility = true;
        },
        async saveCoupon(data) {
            this.modal.saving = true;
            const payload = { ...data, shop: this.activeShop }

            let save = CouponApi.create
            if (!data.id.startsWith('new:')) save = CouponApi.update

            const coupon = await save(payload)
                .catch(error => {
                    console.error(error)
                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        message: this.$t('Coupon could not be saved.'),
                        iconClass: 'fas el-icon-fa-times',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000,
                    })
                });

            if (coupon) {
                this.modal.saving = false;
                this.closeCouponModal();
                this.refetch();

                this.$notify.success({
                    title: this.$t('Coupon has been created successfully!'),
                    iconClass: 'fas el-icon-fa-check',
                    position: 'bottom-left',
                    customClass: 'dark',
                    duration: 8000,
                })
            } else {
                this.modal.saving = false;
            }
        },
        closeCouponModal() {
            this.modal.visibility = false;
        },
        resetCouponModal() {
            this.modal = {
                title: this.$t('Create Coupon'),
                visibility: false,
                loading: false,
                saving: false,
                deleting: false,
                customer: undefined,
                form: {},
                rules: undefined
            };
        },

        openDeleteDialog(coupon) {
            if (!coupon.id || _.startsWith(coupon.id, 'new:') || CouponApi.noDeleteDialog() === 'true') {
                this.deleteCoupon(coupon.id)
            } else {
                this.deleteDialog.visibility = true;
                this.deleteDialog.coupon = coupon;
            }
        },
        closeDeleteDialog() {
            this.deleteDialog.visibility = false;
            this.deleteDialog.loading = false;
            this.deleteDialog.coupon = undefined;

            setTimeout(() => {
                this.deleteDialog.remember = false;
            }, 300);
        },

        async deleteCoupon(id) {
            if (this.deleteDialog.remember) {
                CouponApi.noDeleteDialog(true)
            }

            this.deleteDialog.loading = true;
            this.modal.deleting = true;

            await CouponApi.delete(id)
                .then(() => {
                    this.refetch();
                    this.$notify.success({
                        title: this.$t('The coupon has been deleted successfully'),
                        iconClass: 'fas el-icon-fa-check',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });
                    this.closeCouponModal();
                    this.closeDeleteDialog();
                })
                .catch(() => {
                    this.$notify.error({
                        title: this.$t('The coupon could not be deleted!'),
                        iconClass: 'fas el-icon-fa-xmark',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });
                })

            this.modal.deleting = false;
            this.deleteDialog.loading = false;
        },

        showTillRollDrawer(coupon) {
            this.$set(this.document, 'data', {
                preview: {
                    name: this.$t('Till-Roll PDF'),
                    filename: `${coupon.id}-coupon.pdf`, // TODO: change as soon as the filename becomes configurable
                    pagination: { total: 1, current: 1 },
                    getUrl: () => {
                        // if (coupon.tillRoll) {
                        //     // TODO
                        // }
                        // else return PurchaseApi.couponRenderingUrl(coupon.id, 'till-roll')
                        return PurchaseApi.couponRenderingUrl(coupon.id, 'till-roll')
                    },
                }
            });

            this.document.context = 'till-roll';
            this.document.size = '320px';
            this.document.title = this.$t('Coupon PDF');
            this.document.visibility = true;
            this.document.loading = true;
            this.document.submit = false;
        },
        showLetterDrawer(coupon) {
            this.$set(this.document, 'data', {
                preview: {
                    name: this.$t('Letter PDF'),
                    filename: `${coupon.id}-coupon.pdf`, // TODO: change as soon as the filename becomes configurable
                    pagination: { total: 1, current: 1 },
                    getUrl: () => {
                        // if (coupon.letter) {
                        //     // TODO
                        // }
                        // else return PurchaseApi.couponRenderingUrl(coupon.id, 'letter')
                        return PurchaseApi.couponRenderingUrl(coupon.id, 'letter')
                    },
                }
            });

            this.document.context = 'letter';
            this.document.size = '40%';
            this.document.title = this.$t('Coupon PDF');
            this.document.visibility = true;
            this.document.loading = true;
            this.document.submit = false;
        },

        closeDocument() {
            this.document.visibility = false;
        },
        resetDocument() {
            this.document = {
                visibility: false,
                context: undefined,
                size: '40%',
                title: undefined,
                loading: false,
                saving: false,
                submit: false,
                error: false,
            };

            const iframe = this.$refs['preview-iframe']
            if (iframe) {
                iframe.contentWindow.document.open();
                iframe.contentWindow.document.write('');
                iframe.contentWindow.document.close();
            }
        },
        async printPreview() {
            // this.$refs['pdf-preview'].print();
            await ensureFreshToken();
            const url = this.document.data.preview.getUrl();
            printJS({ printable: url });
        },
        async downloadPreview() {
            await ensureFreshToken();
            const element = document.createElement('a');
            const url = this.document.data.preview.getUrl();
            element.setAttribute('href', `${url}&download`);
            // NOTE: does not work
            // element.setAttribute('download', this.document.data.preview.filename);

            element.style.display = 'none';
            document.body.appendChild(element);

            element.click();

            document.body.removeChild(element);
        },
        previewLoaded() {
            // this.refreshAuthentification();
            if (this.document.data && this.document.data.preview) {
                setTimeout(() => {
                    this.$set(this.document, 'loading', false);
                }, 150)
            }
        },
        previewError(error) {
            let message;
            switch (error.name) {
                case 'MissingPDFException':
                    message = {
                        title: this.$t('An error occurred!'),
                        message: this.$t('Missing PDF'),
                        iconClass: 'fas el-icon-fa-times',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000,
                    }
                    break;

                default:
                    message = {
                        title: this.$t('An error occurred!'),
                        message: this.$t('Preview could not be rendered'),
                        iconClass: 'fas el-icon-fa-times',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000,
                    }
            }

            if (this.document.data && this.document.data.preview) {
                this.resetDocument()
            }

            this.$notify.error(message)
        },
        updatePreviewPagination(key, value) {
            if (this.document.data && this.document.data.preview) {
                let timeout = 0

                if (key === 'current') {
                    if (this.$refs.preview.scrollTop) {
                        timeout = 200
                    }

                    this.$refs.preview.scroll({
                        top: 0,
                        left: 0,
                        behavior: 'smooth'
                    })
                }

                setTimeout(() => {
                    this.$set(this.document.data.preview.pagination, key, value);
                }, timeout);
            }
        },

        activateTab(item) {
            return this.setupStore.activateTab(item);
        },
        updateLoading(value) {
            this.couponStore.updateLoading(value);
        },
        defineItemsPerPage(value) {
            this.couponStore.defineItemsPerPage(value);
        },
        defineCurrentPage(value) {
            this.couponStore.defineCurrentPage(value);
        },
        defineActiveColumns(value) {
            this.couponStore.defineActiveColumns(value);
        },
        defineFilterValue(payload) {
            this.couponStore.defineFilterValue(payload);
        },
        defineFilterVisibility(value) {
            this.couponStore.defineFilterVisibility(value);
        },
        defineSort(payload) {
            this.couponStore.defineSorting(payload);
        },
        fetchCouponsPaginated() {
            return this.couponStore.fetchCouponsPaginated();
        },
        saveFilterVisibility(payload) {
            return this.setupStore.saveFilterVisibility(payload);
        }
    },
    mounted() {
        this.initialize();
    }
};
</script>

<style lang="sass" scoped>
.table-top
    display: block
    .row
        display: flex
        justify-content: space-between
    .transfer
        margin-top: .5rem

.error
    padding: 20px
</style>

<style lang="sass" scoped>
.under-construction
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center
    padding: 4rem
    text-align: center
    i
        font-size: 4rem
        color: rgba(0,0,0,0.2)
    h4
        margin-top: 1rem
        margin-bottom: 0
        font-size: 2rem
        font-weight: 300
        color: rgba(0,0,0,0.3)
.modal-container
    .coupon-modal
        .modal-body
            flex-grow: 1
            overflow: auto
            padding: 0
            max-height: calc(100vh - 66px) // - 69px

.el-drawer__wrapper.document
    ::v-deep .el-drawer
        // min-width: 600px
        // max-width: 90%
        // min-width: 320px
        // max-width: 380px
        .el-form
            display: flex
            flex-direction: column
            .body
                position: relative
                flex-grow: 1
                width: 100%
        iframe,
        .preview
            // width: 100%
            // flex-grow: 1
            // max-height: calc(100vh - 135px)
            position: absolute
            left: 0
            top: 0
            width: 100%
            height: 100%
            max-width: 100%
            max-height: 100%
            overflow: auto
        .pill
            // padding: 2px 6px
            // background: #e2e2e2
            // margin: 2px
            // display: inline-block
            // border-radius: 3px
            &:not(:last-child):after
                content: ', '
                margin-right: 2px
        .from-to b + span.pill
            margin-left: 4px
        .meta
            padding: 20px
            padding-top: 0
            font-size: 0.8rem
            display: grid
            grid-template-rows: auto auto
            grid-template-columns: auto auto
            .subject
                grid-row: 2
                margin-top: 1rem
                b + span
                    margin-left: 4px
            .attachments
                grid-column: 2
                text-align: right
                display: flex
                flex-direction: column
                align-items: flex-end
                /* justify-content: flex-end */
                ul
                    list-style: none
                    padding: 0
                    margin: 0
    .drawer-footer
        align-items: center
    .preview
        padding: 2rem 20px
        display: flex
        align-items: center
        justify-content: center
        & > span
            width: 100%
            flex-grow: 1
            margin: auto 0
        &.loaded
            background: #babfc3
            & > span
                box-shadow: 0 4px 5px 0 rgba(0,0,0,0.14), 0 1px 10px 0 rgba(0,0,0,0.12), 0 2px 4px -1px rgba(0,0,0,0.3)
</style>
